import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import MatchAccaBetContentImpl from './match-acca-bet-content.js';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * MatchAcca bet content view.
 *
 * @class MatchAccaBetContent
 * @memberof Mojito.Modules.BetslipView
 */

/**
 * SingleBet prop types.
 *
 * @property {boolean} [suspended = false] - Flag indicating whether the bet is suspended.
 * @property {boolean} [expired = false] - Flag indicating whether the bet is expired.
 * @property {Mojito.Services.Betslip.types.Bet} bet - Bet.
 * @property {Mojito.Services.Betslip.types.Betslip} [betslip = {}] - Betslip.
 * @property {boolean} [hasHcapChange = false] - Flag to indicate if bet has handicap changes.
 * @property {boolean} [hasOddsChange = false] - Flag to indicate if bet has odds changes.
 * @property {boolean} [isBetEachWay = false] - Flag to indicate if betWay is EACH_WAY.
 * @property {Function} [cbRemoveBet = ()=>{}] - Callback for when a bet is removed from the slip.
 * @property {Function} [onStakeInputFocus = () => {}] - Callback on stake input focus.
 * @property {boolean} [showStake] - Flag indicating whether the stake input should be shown.
 * @property {boolean} [showEachWay = false] - Flag to show each way toggle button.
 * @property {Mojito.Services.Betslip.types.BetStake} [betStake = {}] - Stake information.
 * @property {object} [suspendedParts = {}] - Map of suspended parts of bet.
 *
 * @memberof Mojito.Modules.BetslipView.SingleBet
 */
const propTypes = {
    suspended: PropTypes.bool,
    expired: PropTypes.bool,
    bet: PropTypes.object.isRequired,
    betslip: PropTypes.object,
    hasHcapChange: PropTypes.bool,
    hasOddsChange: PropTypes.bool,
    isBetEachWay: PropTypes.bool,
    betStake: PropTypes.object,
    showEachWay: PropTypes.bool,
    showStake: PropTypes.bool,
    onStakeInputFocus: PropTypes.func,
    cbRemoveBet: PropTypes.func,
    suspendedParts: PropTypes.objectOf(
        PropTypes.shape({
            isSuspended: PropTypes.bool,
        })
    ),
};

const defaultProps = {
    betslip: {},
    suspended: false,
    betStake: {},
    hasHcapChange: false,
    hasOddsChange: false,
    showStake: false,
    showEachWay: false,
    isBetEachWay: false,
    onStakeInputFocus: noop,
    cbRemoveBet: noop,
    suspendedParts: {},
};

export default UIView('MatchAccaBetContent', MatchAccaBetContentImpl, propTypes, defaultProps);
